<template>
  <div
    :id="id"
    class="tab-pane fade header-main-menu-content-list"
    :aria-labelledby="targetId"
  >
    <nuxt-link
      v-for="item in menuData"
      :key="item.type"
      class="header-main-menu-content-link"
      :to="item.link"
      exact
    >
      <i
        v-if="id === 'HeaderMainMenuSupport'"
        :class="`mc-${item.type === 'support' ? 'faq' : item.type}`"
      ></i>
      <i v-else :class="`mc-${item.type}`"></i>
      <span>{{ $t(`layout.Header.list.${item.type}`) }}</span></nuxt-link
    >
  </div>
</template>

<script>
import { computed, defineComponent, useStore } from '@nuxtjs/composition-api'
import useUser from '../../../composables/useUser'
import useComp from '../../../composables/useComp'

export default defineComponent({
  components: {},
  props: {
    id: {
      type: String,
      default: null
    },
    targetId: {
      type: String,
      default: null
    },
    menuData: {
      type: Array,
      default() {
        return []
      }
    }
  },
  setup(props, context) {
    const store = useStore()
    const isMobile = computed(() => store.state.isMobile)
    const { user } = useUser(context)
    const templateId = computed(() => process.env.TEMPLATE_ID)
    const {
      compMainMenuSecondaryGameList,
      compMainMenuSecondarySupportList,
      compMenuSecondaryWalletList
    } = useComp()

    return {
      isMobile,
      user,
      templateId,
      compMainMenuSecondaryGameList,
      compMainMenuSecondarySupportList,
      compMenuSecondaryWalletList
    }
  }
})
</script>
